import BaseComponent from "../../BaseComponent";
import {ComponentContext} from "../../IComponent";
import m, {Vnode} from "mithril";
import UploadedFilesComponent from "../../shared/UploadedFileComponent";


type TFormValues = {
    question: string,
    attachments: File[],
};

export default class DesignResearch extends BaseComponent {

    private readonly questions: {[question_key: string]: string};
    private readonly links: {[link_key: string]: string};

    private readonly uploadedFiles = new UploadedFilesComponent();

    private readonly formValues: TFormValues = {
        question: '',
        attachments: [],
    }

    private sending = false;

    constructor($component: JQuery<HTMLElement>, context?: ComponentContext) {
        super($component, context);

        const data = JSON.parse($component.find("script").text());
        this.questions = data.questions;
        this.links = data.links;
    }

    init(): void {
        m.mount(this.$component.get(0), this);
    }

    private async send() {
        const formData = new FormData();
        this.formValues.attachments.forEach((attachment: File) => {
            formData.append('attachments[]', attachment);
        });
        formData.append('question', this.formValues.question);
        try {
            this.sending = true;
            const payload = await this.context.naja.makeRequest('POST', this.links.startResearch, formData);

            // Naja, what's wrong with you!!!
            if (payload.forceRedirect) {
                window.location.href = payload.forceRedirect;
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.sending = false;
            m.redraw();
        }
    }

    view(): Vnode {
        return m(".chatbot-conversation-wrapper.chatbot-start.flex-column.gap-3.p-3", [
            m(".chatbot-message.mx-auto", [
                m(".chatbot-avatar.mx-auto.mb-3"),
                m("p.fs-5.fw-light.text-center.m-0", [this.translator.translate('chatbot.i_am_chatbot'),m("br"),this.translator.translate('chatbot.i_can_do_design')])
            ]),
            m(".chatbot-start-form.card.rounded-3.shadow-lg.mx-auto", [
                m("a.p-3.position-absolute.top-0.left-0.z-1", {
                    href: this.links.default
                },  [
                    m("i.bi.bi-arrow-left")
                ]),
                m(".card-header.border-0.text-center.flex-column.gap-1.p-3", [
                    m("h3.card-title.fs-4.fw-light", this.translator.translate('chatbot.new_chat')),
                    m("h6.card-title.fs-7.fw-light", this.translator.translate('chatbot.design_research'))
                ]),
                m(".card-body", [
                    m(".card-body.d-flex.flex-column.gap-2.pt-0", [
                        m(".text-secondary.m-0.mb-1.d-flex", [
                            m("span.me-2.align-self-center", this.translator.translate("chatbot.question_tips"))
                        ]),
                        ...Object.entries(this.questions).map(([key, value]) =>  m("button.btn.btn-sm.btn-flat-dark.justify-content-start.text-start.text-wrap", {
                            onclick: () => this.formValues.question = value,
                        }, value)),
                        m(this.uploadedFiles),
                    ]),
                    m(".DesignResearch.card-body.chatbot-input.d-flex.flex-row.flex-nowrap.position-relative.w-100.gap-2.pt-0", [
                        m("textarea.form-control.auto-resize", {
                            name: 'question',
                            placeholder: this.translator.translate('chatbot.ask_me'),
                            value: this.formValues.question,
                            oninput: e => this.formValues.question = e.target.value,
                        }),
                        m("label.btn.btn-flat-primary.position-relative",{
                            for: 'attachments',
                            title: this.translator.translate('attachment'),
                        }, [
                            m("input.d-none", {
                                id: "attachments",
                                name: "attachments",
                                type: "file",
                                multiple: true,
                                onchange: e => {
                                    this.uploadedFiles.addFiles(Array.from(e.target.files));
                                    this.formValues.attachments = this.uploadedFiles.getFiles();
                                },
                            }),
                            m("i.bi.bi-paperclip.m-0")
                        ]),
                        m("button.btn.btn-flat-primary", {
                            title: this.translator.translate("chatbot.start_chat"),
                            disabled: this.sending || !this.formValues.question,
                            onclick: () => this.send(),
                        }, [
                            m("i.bi.bi-send")
                        ])
                    ])
                ])
            ])
        ]);
    }

}
